import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { MembershipType } from '__generatedTypes__/globalTypes'
import { getMembershipLabelByType } from 'utils/getMembershipLabelByType'
import { validateRequired } from 'utils/validation'
import { SelectField } from '../Select'
import { PlatformSlug } from '../../constants/consts'
import { getMembershipLevelsConfig } from '../MembershipLevelSelect/platformConfig'

interface IProps {
  name?: string
  minMembershipLevel?: MembershipType
  platform?: PlatformSlug
}

// Deprecated. Please use components/MembershipLevelSelect/MembershipLevelSelect.tsx instead
const SelectMembershipType: FC<IProps> = ({
  name = 'membershipLevel',
  minMembershipLevel = MembershipType.Free,
  platform: platformProp,
}) => {
  const { platform: platformParam } = useParams()
  const platform = (platformProp ?? platformParam) as PlatformSlug

  const availableMembershipOptions = () => {
    const config = getMembershipLevelsConfig(platform)
    const options: MembershipType[] = []

    if (minMembershipLevel === MembershipType.Free) {
      options.push(MembershipType.Free)
    }

    if (config?.hasPremium && minMembershipLevel !== MembershipType.PremiumMax) {
      options.push(MembershipType.Premium)
    }

    if (config?.hasPremiumMax) {
      options.push(MembershipType.PremiumMax)
    }

    return options
  }

  return (
    <SelectField<{ id: MembershipType }>
      name={name}
      items={availableMembershipOptions().map((item) => ({ id: item }))}
      renderItem={(item) => getMembershipLabelByType[item.id]}
      getItemLabel={(item) => getMembershipLabelByType[item.id]}
      label="Membership Access"
      fullWidth
      validate={validateRequired}
    />
  )
}

export default SelectMembershipType
